import React, { useCallback, useEffect, useState } from "react";
import ButtonHolder from "../ButtonHolder";
import MessageBox from "../MessageBox";
import { LoadingIndicator, TwoSwitch } from  "../../lib/iprs-react-library/src/index";
import styles from "./Review.module.css"; // Import the CSS module

import { ReactComponent as phoneIcon   }    
            from '../AppointmentCapture/appointment_type_images/musculoskeletal.svg'
import { getImageForAppTypeURL } from "../AppointmentCapture/AppTypeList";
import { use } from "react";
/**
 * REACT component to render a form to review a booking before submitting. */
const Review = ({ api, doUpdate, appState, loading: parentLoading }) => {
    const {
        websiteConfig: {
            ShowPatientReview,
            ShowContactAndGPUpdate = false,
            ShowNotificationOptions,
            ShowAppTypeReview,
            LocationText,
            CaseID
        },
        personalData: {
            DOB,
            personTitle,
            Forename: firstName,
            Surname: lastName
        } = {},
        appointmentType = {}
    } = appState;

    const bookingMade = 0 < Number.parseInt(appState.bookingId);
    const confirmText = bookingMade ? "Confirm your booking" : "Confirm your Referral";

    const DOBDt = Date.parse(DOB);
    const DOBSt = isNaN(DOBDt)
        ? "Invalid Date"
        : new Intl.DateTimeFormat("en-GB", { dateStyle: "long" }).format(DOBDt);
    
    /* turn on if it's configured or if didn't make a booking (and there's a valid DOB).
    The latter added to override the setting where we are just making a referral but no 
    booking */
    const showPatientReview = ShowPatientReview || (!isNaN(DOBDt) && !bookingMade);

    const { startTime } = appState;

    const {
        Description: appDesc,
        Title: appTitle,
        ImageURL: appImage
    } = appointmentType ? appointmentType : {};

    const appTypeIcon = getImageForAppTypeURL(appImage);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleCancel = useCallback(() => {
        doUpdate({ doCancel: true });
    }, [doUpdate]);

    const [formState, setFormState] = useState({
        email: "",
        sms: "",
        gpName: "",
        gpSurgery: "",
        gpAddress: "",
        PatientHomeAddress: {
            Address1: "",
            Address2: "",
            Town: "",
            County: "",
            Postcode: "",
            Country: "GB"
        }
    });
    const [formTouched, setFormTouched] = useState(false);

    const shouldAllowSubmitAttempt = formTouched || 
    Object.entries(formState).some(([key, value]) => {
        if (key === "PatientHomeAddress") {
            return Object.values(value).some(
                (addressField) => addressField != null && addressField.trim() !== ""
            );
        }
        return value != null && value.trim() !== "";
    });
    const [submitAttempted, setSubmitAttempted] = useState(false);

    const handleOK = () => {
        if (!ShowContactAndGPUpdate) {
            doUpdate({ reviewOK: true });
            return;
        }
        // check the form is valid before submitting
        const formValid = Object.entries(formState).every(([key, value]) => {
            if (key === "PatientHomeAddress") {
                return Object.keys(value).every(
                    (addressField) => document.getElementById(addressField.toLowerCase()).validity.valid
                );
            }
            return document.getElementById(key).validity.valid;
        });

        setSubmitAttempted(true);

        if (!formValid) {
            setError("Please fill in all required fields correctly.");
            return;
        }
        setError(null);
        setLoading(true);
        api.transact("UpdatePatient", {
                  PatientIdentifier: {
                      CaseID: CaseID
                  },
                  Patient: {
                      GpName: formState.gpName,
                      GpSurgery: formState.gpSurgery,
                      GpAddress: formState.gpAddress,
                      PatientMobileNumber: formState.sms,
                      PatientEmailAddress: formState.email,
                      PatientHomeAddress: formState.PatientHomeAddress
                  }
              }).then(() => {
            doUpdate({ reviewOK: true });
        })
        .catch(e => {
            setError(e.message);
        })
        .finally(() => {
            setLoading(false);
        }
        );
    };

    return (
        <>
            <TwoSwitch test={showPatientReview || bookingMade}>
                <>
                    <h2 className="center">One last thing</h2>
                    <p>Confirm the below details and we'll do the rest</p>
                </>
            </TwoSwitch>

            <TwoSwitch test={bookingMade}>
            <TwoSwitch test={LocationText}>
                <MessageBox title="Where" image={appTypeIcon}>
                    <p className="content-boxes__box-content-text">
                        {LocationText}
                    </p>
                </MessageBox>
            </TwoSwitch>

            <TwoSwitch test={ShowAppTypeReview}>
                <MessageBox title="What" image={appTypeIcon}>
                    <strong>{appTitle}</strong>
                    <br />
                    {appDesc}
                </MessageBox>
            </TwoSwitch>

            <MessageBox title="When" image={appTypeIcon}>
                <p class="content-boxes__box-content-text">
                    <strong>
                        {new Intl.DateTimeFormat("en-GB", {
                            dateStyle: "full",
                            timeStyle: "short"
                        }).format(startTime)}
                    </strong>
                    <br />
                    <TwoSwitch test={ShowNotificationOptions}>
                        <span className="content-boxes__optionset">
                            <label className="form__checkbox" for="email">
                                Email
                                <input
                                    id="email"
                                    className="form__checkbox-input"
                                    type="checkbox"
                                    name="email"
                                    checked={true}
                                />
                            </label>

                            <label class="form__checkbox" for="sms">
                                SMS
                                <input
                                    id="sms"
                                    className="form__checkbox-input"
                                    type="checkbox"
                                    name="sms"
                                    checked={true}
                                />
                            </label>
                        </span>
                    </TwoSwitch>
                </p>
            </MessageBox>

            </TwoSwitch>

            <TwoSwitch test={showPatientReview}>
                <MessageBox title="Who" image={appTypeIcon}>
                    <p class="content-boxes__box-content-text">
                        Patient Name:{" "}
                        <strong>
                            {personTitle} {firstName} {lastName}
                        </strong>
                        <br />
                        Date of birth: <strong>{DOBSt}</strong>
                    </p>
                </MessageBox>
            </TwoSwitch>

            <TwoSwitch test={ShowContactAndGPUpdate}>
                <div className={submitAttempted ? styles.validating : styles.notTouched}>
                <ContactAndGPUpdateComp caseID={CaseID} api={api} 
                formState={formState} setFormState={setFormState} setFormTouched={setFormTouched} />
                </div>
            </TwoSwitch>

            <ButtonHolder
                action={handleOK}
                cancel={handleCancel}
                actionTxt={confirmText}
                cancelTxt={"Edit your booking"}
                enabled={!parentLoading && !loading && 
                    (shouldAllowSubmitAttempt || !ShowContactAndGPUpdate) }
            />
            <LoadingIndicator loading={loading} />
            {error && <p className="error">{error}</p>}
        </>
    );
};

const ContactUpdateComp = ({ formState, handleInputChange }) => {

    return (
        <>
            <MessageBox title="Contact" image={phoneIcon}>
                <p className="content-boxes__box-content-text">
                    <strong>
                        Please confirm your email address and mobile number below:
                    </strong>
                </p>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="email">
                        Email&nbsp;*
                    </label>
                    <input
                        id="email"
                        className={styles['form__text-input']}
                        type="email"
                        name="email"
                        value={formState.email}
                        onChange={handleInputChange}
                        required={true}
                        pattern="^.+@.+$"
                        autoComplete="email"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter a valid email address
                    </span>
                </div>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="sms">
                        SMS&nbsp;*
                    </label>
                    <input
                        id="sms"
                        className={styles['form__text-input']}
                        type="tel"
                        name="sms"
                        value={formState.sms}
                        onChange={handleInputChange}
                        required={true}
                        pattern="^\+?([0-9]\s?){10,14}$"
                        autoComplete="tel"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter a valid mobile number
                    </span>
                </div>
                <p className="content-boxes__box-content-text" >
                    <em>
                        By providing your mobile number, you
                        consent to IPRS Health sending text
                        messages and leaving voicemails if
                        we cannot reach you.
                    </em>
                </p>
            </MessageBox>
        </>
    );
}

const gen4CharRegex = "^\\s?(\\w'?([\\d\\.,-_\\s]|\\.\\s|,\\s)?){4,}$";

const AddressUpdateComp = ({ formState, handleInputChange }) => {
    const handleAddressChange = (e) => {
        const { name, value } = e.target;
        handleInputChange({
            target: {
                name: "PatientHomeAddress",
                value: {
                    ...formState.PatientHomeAddress,
                    [name]: value,
                },
            },
        });
    };

    return (
        <>
            <MessageBox title="Address" image={phoneIcon}>
                <p className="content-boxes__box-content-text">
                    <strong>
                        Please confirm your address below:
                    </strong>
                </p>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="address1">
                        Address Line 1&nbsp;*
                    </label>
                    <input
                        id="address1"
                        className={styles['form__text-input']}
                        type="text"
                        name="Address1"
                        value={formState.PatientHomeAddress.Address1}
                        onChange={handleAddressChange}
                        required={true}
                        pattern={gen4CharRegex}
                        autoComplete="address-line1"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter your address line 1. Please use at least 4 characters excluding space and punctuation.
                    </span>
                </div>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="address2">
                        Address Line 2
                    </label>
                    <input
                        id="address2"
                        className={styles['form__text-input']} 
                        type="text"
                        name="Address2"
                        value={formState.PatientHomeAddress.Address2}
                        onChange={handleAddressChange}
                        required={false}
                        pattern={gen4CharRegex}
                        autoComplete="address-line2"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter your address line 2. Please use at least 4 characters excluding space and punctuation.
                    </span>
                </div>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="town">
                        Town&nbsp;*
                    </label>
                    <input
                        id="town"
                        className={styles['form__text-input']}
                        type="text"
                        name="Town"
                        value={formState.PatientHomeAddress.Town}
                        onChange={handleAddressChange}
                        required={true}
                        pattern={gen4CharRegex}
                        autoComplete="address-level2"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter your town. Please use at least 4 characters excluding space and punctuation.
                    </span>
                </div>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="county">
                        County
                    </label>
                    <input
                        id="county"
                        className={styles['form__text-input']}
                        type="text"
                        name="County"
                        value={formState.PatientHomeAddress.County}
                        onChange={handleAddressChange}
                        required={false}
                        pattern={gen4CharRegex}
                        autoComplete="address-level1"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter your county. Please use at least 4 characters excluding space and punctuation.
                    </span>
                </div>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="postcode">
                        Postcode&nbsp;*
                    </label>
                    <input
                        id="postcode"
                        className={styles['form__text-input']}
                        type="text"
                        name="Postcode"
                        value={formState.PatientHomeAddress.Postcode}
                        onChange={handleAddressChange}
                        required={true}
                        pattern="^([A-Z]{1,2}[0-9][0-9]?[A-Z]?)?\s*([0-9][A-Z]{2})$"
                        autoComplete="postal-code"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter your postcode. 
                    </span>
                </div>
                <div className={styles.form__input_wrapper} style={{ display: 'none' }}>
                    <label className={styles.form__text_label} htmlFor="country">
                        Country
                    </label>
                    <input
                        id="country"
                        className={styles['form__text-input']}  
                        type="text"
                        name="Country"
                        value={formState.PatientHomeAddress.Country}
                        onChange={handleAddressChange}
                        required={false}
                        pattern="^(\w'?([\.,-_\s]|\.\s)?){2,}$"
                        autoComplete="address-level0"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter your country. 
                    </span>
                </div>
            </MessageBox>
        </>
    );  
}

const GPUpdateComp = ({ formState, handleInputChange }) => {

    return (
        <>
            <MessageBox title="GP Details" image={phoneIcon}>
                <p class="content-boxes__box-content-text">
                    To provide you with the best possible care, we may need to 
                    contact your GP. Please provide their details below. IPRS
                    Health is required to have this the correct details so we
                    can continue with your assessment.
                </p>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="gpName">
                        GP Name&nbsp;*
                    </label>
                    <input
                        id="gpName"
                        className={styles['form__text-input']}
                        type="text"
                        name="gpName"
                        value={formState.gpName}
                        onChange={handleInputChange}
                        required={true}
                        pattern={gen4CharRegex}
                        autoComplete="name"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter your GP's name. Please use at least 4 characters excluding 
                        space and punctuation.
                    </span>
                </div>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="gpSurgery">
                        GP Surgery&nbsp;*
                    </label>
                    <input
                        id="gpSurgery"
                        className={styles['form__text-input']}
                        type="text"
                        name="gpSurgery"
                        value={formState.gpSurgery}
                        onChange={handleInputChange}
                        required={true}
                        pattern={gen4CharRegex}
                        autoComplete="organization-title"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter your GP's surgery. Please use at least 4 characters 
                        excluding space and punctuation.
                    </span>
                </div>
                <div className={styles.form__input_wrapper}>
                    <label className={styles.form__text_label} htmlFor="gpAddress">
                        GP Address&nbsp;*
                    </label>
                    <textarea
                        id="gpAddress"
                        className={styles['form__text-input']}
                        name="gpAddress"
                        value={formState.gpAddress}
                        onChange={handleInputChange}
                        rows="4"
                        required={true}
                        pattern="^(\w'?([\.,-_\s]|\.\s|,\s)?){20,}$"
                        autoComplete="street-address"
                    />
                    <span className={styles.form__input_hint}>
                        Please enter your GP's address. Please use at least 20 characters 
                        excluding space and punctuation.
                    </span>
                </div>
            </MessageBox>
        </>
    );
}

const ContactAndGPUpdateComp = ({ api, caseID, formState, setFormState, setFormTouched }) => {
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormTouched(true); // should be moved up. Refactor for another day
        setFormState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        // get the contact and gp details
        api.transact("GetPatient", {
            PatientIdentifier: {
                CaseID: caseID
            }
        })
            .then(r => r.apiResult)
            .then(r => r.Patient)
            .then(Patient => {
                setFormState({
                    email: Patient.PatientEmailAddress,
                    sms: Patient.PatientMobileNumber,
                    gpName: Patient.GpName,
                    gpSurgery: Patient.GpSurgery,
                    gpAddress: Patient.GpAddress,
                    PatientHomeAddress: Patient.PatientHomeAddress?? {
                        Address1: "",
                        Address2: "",
                        Town: "",
                        County: "",
                        Postcode: "",
                        Country: "GB"
                    }
                });
            })
            .catch(e => {
                console.error(e);
            });
    }, []);

    return (
        <>
            <ContactUpdateComp
                formState={formState}
                handleInputChange={handleInputChange}
            />
            <AddressUpdateComp formState={formState} handleInputChange={handleInputChange} />
            <GPUpdateComp formState={formState} handleInputChange={handleInputChange} />
        </>
    );
}

export default Review;
